import * as React from 'react';
import { makeStyles, IconButton, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { fontFamilies } from '../theme/text';
import { status, neutral } from '../theme/colors';
import { Close } from '@material-ui/icons';

export interface AnnouncementProps {
  /** Announcement level: Primary or Secondary (dark or light)*/
  type: 'primary' | 'secondary';
  /** Custom Styles */
  className?: string;
  /** arbitrary HTML content, intended for use with TinyMCE */
  content?: string;
  /** Display close button to allow user to hide the announcement */
  hasExitIcon: boolean;
  /** function to trigger on close button click */
  onClose?: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const useStyles = makeStyles<Theme, { type: 'primary' | 'secondary'; hasExitIcon: boolean }>({
  root: (props) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: 2,
    fontSize: 14,
    letterSpacing: '-0.1px',
    padding: props.hasExitIcon ? '0 0 0 20px' : '0 20px',
    marginBottom: 20,
    fontFamily: fontFamilies.heading
  }),
  primary: {
    backgroundColor: status.info.dark,
    border: `solid 1px ${status.info.dark}`,
    color: '#fff'
  },
  secondary: {
    backgroundColor: status.info.light,
    border: `solid 1px ${status.info.medium}`,
    color: neutral[600]
  },
  iconButtonWrapper: {
    padding: '0 10px'
  },
  closeIcon: (props) => ({
    color: props.type == 'primary' ? neutral[100] : neutral[600]
  })
});

/**
 * Component to render site wide announcements with HTML content generated by TinyMCE
 */
const Announcement = ({ type, className, content, hasExitIcon, onClose }: AnnouncementProps) => {
  const classes = useStyles({ type, hasExitIcon });
  if (!content) {
    return <div />;
  }

  return (
    <div
      className={clsx(
        classes.root,
        className,
        type == 'primary' && classes.primary,
        type == 'secondary' && classes.secondary
      )}
    >
      <div dangerouslySetInnerHTML={{ __html: content }}></div>
      {hasExitIcon && (
        <div className={classes.iconButtonWrapper}>
          <IconButton
            size="small"
            edge="end"
            onClick={(event) => {
              onClose(event);
            }}
          >
            <Close className={classes.closeIcon} />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default Announcement;
